module.exports = __webpack_public_path__ + "media/images/emblems/Grone-86f7462ad3711b9e16ce487ed7066f8e.png";